module.exports = __webpack_public_path__ + "static/media/logo-levo-dark.4ef4a70f.svg";